<template>
    <div>
        <div class="client_header">
            <div class="logo">
                <img src="../../assets/img/login_logo.png" alt="" style="width: 54px;height: 51px;">
                <p class="logo_title">汇智衣工业科技</p>
            </div>
            <div>
                <span style="color: #fff;display: inline-block;width: 54px;height: 54px;">
                    <img src="../../assets/img/avatar.png" alt="" style="width: 100%;height: 100%;vertical-align: middle;">
                </span>
                <span class="username"> {{ userName }}</span>
                <el-button class="logout" @click="logoutBtn">{{$t('meg.logout')}}</el-button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { logoout } from "@/api/login.js"
import { ElMessage, ElMessageBox } from 'element-plus'
import { useRouter } from 'vue-router';
const userName = localStorage.getItem("userName")
const router = useRouter()
const logoutBtn = () => {
    ElMessageBox.confirm(
    '确定注销并退出系统吗？',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(() => {
     logoout().then(res => {
        if(res.data.code == 200) {
            router.push("/login")
        }
    })
    })
   
}
</script>

<style scoped>
*{
    margin: 0;
    padding: 0;
}
.client_header {
    height: 95px;
    display: flex;
    justify-content: space-around;
    background-color: #333;
    box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
}

.logo {
    width: 54px;
    height: 51px;
    margin-top: 15px;
}
.logo_title {
    width: 84px;
    margin-left: -15px;
    font-size: 12px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: bold;
    color: #FFFFFF;
    margin-top: 7px;
}
.username {
    line-height: 95px;
    font-size: 16px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
    margin-left: 33px;
}
.logout {
    width: 113px;
    height: 43px;
    border-radius: 0px 0px 0px 0px;
    background: transparent;
    opacity: 1;
    border: 1px solid #707070;
    font-size: 16px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
    margin-left: 33px;
}
</style>
